import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import { ElLoading } from "element-plus";
import i18n from "/src/utils/i18n";

import { Uploader, Overlay, Notify } from "vant";

import lodash from "lodash";

import "vant/lib/index.css";
import "normalize.css/normalize.css";
import "element-plus/dist/index.css";

// global css
import "@/styles/index.scss";
import "./common/font/font.css";

const app = createApp(App);

app.use(ElementPlus, {
  i18n: (key, value) => i18n.global.t(key, value)
});
app.directive('loading', ElLoading.directive);
app.use(Uploader);
app.use(Overlay);
app.use(Notify);

app.config.globalProperties.$lodash = lodash;

// 图片地址
app.config.globalProperties.oAssets = process.env.BASE_IMG;

app.use(i18n);
app.use(router);
app.use(store);

app.mount("#app");
